import PartnershipDetail from './PartnershipDetail.vue';

export default PartnershipDetail;
